import { useState } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import * as React from 'react';
import { CaretSortIcon } from '@radix-ui/react-icons';
import { Button } from '@/components/shadcn/button';
import { regions } from '@/utils/regions';
import RegionsTable from '@/components/ui/privacy/regions/RegionsTable';

export type Region = {
  country: string;
  state: string;
};

function columns(
  setPage: React.Dispatch<React.SetStateAction<number>>,
): ColumnDef<Region>[] {
  return [
    {
      accessorKey: 'country',
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            className="px-0"
            onClick={() => {
              column.toggleSorting(column.getIsSorted() === 'asc');
              setPage(1);
            }}>
            Country
            <CaretSortIcon className="ml-2 size-4" />
          </Button>
        );
      },
    },
    {
      accessorKey: 'state',
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            className="px-0"
            onClick={() => {
              column.toggleSorting(column.getIsSorted() === 'asc');
              setPage(1);
            }}>
            State/Province
            <CaretSortIcon className="ml-2 size-4" />
          </Button>
        );
      },
    },
  ];
}

export default function Page() {
  const [page, setPage] = useState(1);

  return (
    <div className="container mx-auto py-10">
      <RegionsTable
        columns={columns(setPage)}
        data={regions}
        page={page}
        setPage={setPage}
      />
    </div>
  );
}
